import { gql } from '@apollo/client';

export default gql`
  query retainerProduct {
    retainerProduct {
      id
      price
      showInStore
      overPrice
      productId
      product {
        id
        name
        arches
        isRetainer
        isEot
        description
        defaultSubscriptionRetainer
        featuredImage
        productType
        productFeatures {
          id
          text
        }
      }
    }
  }
`;
